/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-10 12:06:12
 * @FilePath: /portal2/unifyxp-v2-store-portal/src/pages/ProductEditor/tools/Submit/ProductSubmit.tsx
 */
import { store } from 'src/store';
import { getStateSelector } from '../selectors';
import { validate as validateSet } from '../../ProductSet/slice';
import { validate as validateSimple } from '../../SimpleProduct/Slice';
import { validate as validateVariant } from '../../VariantProduct/Slice';

import {
  submitProductThunk as submitProduct,
  activateProductThunk as activateProduct,
  draftProductThunk as draftProduct,
  archiveProductThunk as archiveProduct,
} from 'src/pages/ProductEditor/tools/commonRequests';
import { EnumStatus, EnumProductType } from 'src/types/common/product';
import { settleData as simpleSettle } from '../../SimpleProduct/tools/submitData';
import { settleData as setSettle } from '../../ProductSet/tools/submitData';

import { settleData as variantSettle } from '../../VariantProduct/data/submitData';

import { reducer } from '../dataDict';
export const getProduct = (status, productType: EnumProductType) => {
  const validator = {
    [EnumProductType.Set]: validateSet,
    [EnumProductType.Simple]: validateSimple,
    [EnumProductType.Variant]: validateVariant,
  }[productType];
  const settle = {
    [EnumProductType.Set]: setSettle,
    [EnumProductType.Simple]: simpleSettle,
    [EnumProductType.Variant]: variantSettle,
  }[productType];

  if (validator && settle) {
    store.dispatch(validator({ savedType: status })); //validation
    const _s = store.getState();
    const product = getStateSelector(reducer[productType], settle)(_s);

    return product;
  } else {
    return {};
  }
};
export const productSubmit = (params?) => {
  const { cb, hideMsg, productType, status } = params || {};
  const productSet = getProduct(status, productType);
  const { dataValid } = productSet;
  if (dataValid) {
    store.dispatch(submitProduct({ prod: productSet, hideMsg }));
    if (cb) cb(productSet);
  }
};
export const productDraft = ({ productType }) => {
  const productSet = getProduct(EnumStatus.Draft, productType);
  const { dataValid } = productSet;
  if (dataValid) {
    store.dispatch(draftProduct(productSet));
  }
};
export const productActive = ({ productType }) => {
  const productSet = getProduct(EnumStatus.Active, productType);

  const { dataValid } = productSet;

  if (dataValid) {
    store.dispatch(activateProduct(productSet));
  }
};
export const productArchive = ({ productType }) => {
  const productSet = getProduct(EnumStatus.Active, productType);
  const { dataValid } = productSet;
  if (dataValid) {
    store.dispatch(archiveProduct(productSet));
  }
};
